import { render, staticRenderFns } from "./MainKindContents.vue?vue&type=template&id=53d5c2b8&scoped=true&"
import script from "./MainKindContents.vue?vue&type=script&lang=js&"
export * from "./MainKindContents.vue?vue&type=script&lang=js&"
import style0 from "./MainKindContents.vue?vue&type=style&index=0&id=53d5c2b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d5c2b8",
  null
  
)

export default component.exports